import React from "react";
import About from "../Components/About/About";
import Contact from "../Components/Contact/Contact";
import Experience from "../Components/Experience/Experience";
import Footer from "../Components/Footer/Footer";
import Hero from "../Components/Home";
import Navbar from "../Components/Navbar/Navbar";
import Project from "../Components/Project/Project";
import Sidebar from "../Components/Sidebar/Sidebar";
import Skills from "../Components/SkillSection/Skills";

const Home = () => {
  return (
    <div style={{ zIndex: "4" }}>
      <Navbar />
      <Sidebar />
      <Hero />
      <About />
      <Skills />
      <Experience />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
};

export default Home;
